module.exports = __webpack_public_path__ + "img/10.3c342f7d.jpg";